module.exports = __webpack_public_path__ + "img/officialAccount.1c87e1d1.png";